import { ChangeDetectorRef, Component } from '@angular/core';
import { ClientListComponent } from '../client-list/client-list.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ClientBaseModel } from 'src/app/core/models/members/client/client-base-model';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { ClientListService } from 'src/app/core/services/list-services/client-list.service';
import { InviteModalService } from 'src/app/core/services/modal-services/invite-modal.service';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { ClientPickListTableConfig } from './configs/client-picklist.config';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { TableConfigService } from 'src/app/core/services/table-config.service';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-client-picklist',
  templateUrl: './client-picklist.component.html',
  styleUrls: ['./client-picklist.component.scss']
})
export class ClientPicklistComponent extends ClientListComponent {

  selectedModelIdFromCheckedList: string = "";

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected override taskModalService: TaskModalService,
    protected override myInviteModalService: InviteModalService,
    protected override clientListService: ClientListService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override openModalService: OpenModalService,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(taskModalService, clientListService, myInviteModalService, tableConfigService, myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  override ngOnInit(): void {

    this.tableConfig = new ClientPickListTableConfig();
    
    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));
        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.clientListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.clientListService.resultItems$;
    this.total = this.clientListService.total$;
    this.isLoading = this.clientListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.clientListService.totalRecords;
      this.serviceData.pageSize = this.clientListService.pageSize;
      this.serviceData.pageIndex = this.clientListService.pageIndex;
    })
    this.unsubscribe.push(subscr3);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((clientModel: ClientBaseModel) => {
        this.getEntityPhoto(clientModel, EntityTypeEnum.Client);
      });
    });
    this.unsubscribe.push(subscr2);

    this.changeDetectorRef.detectChanges();

  }

  selectClients() {
    this.submitted = true;
    this.selectedModelIdFromCheckedList = "";
    this.checkedValGet.forEach((model: any) => {
      if(model.id){
        this.selectedModelIdFromCheckedList = model.id;
      }
    })
    this.selectClient(this.selectedModelIdFromCheckedList);
  }

  selectClient(clientId: string) {
    this.submitted = true
    if (clientId != '') {
      var sub: Subscription = this.myFileApiService.getClient(clientId)
        .subscribe((client: ClientModel | undefined) => {
          if (client) {
            this.model = client;
            this.legacyModelCheckAndSet();
            this.referenceModel = this.model;
            this.referenceModelChange.emit(this.referenceModel);
          }
          this.submitted = false;
          sub.unsubscribe();
        });
    } else {
      this.toasterNotificationService.showWarning($localize`:@@:Select a client`, $localize`:@@Toast_Error_GeneralTitle:Error`);
      this.submitted = false;
    }
  }

  override rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.editClientModal(this.clientListService, rowAction.model.id, undefined, undefined);
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.deleteData(rowAction.model.id)
        }
        break;
      case ActionIdEnum.Notes:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.editClientModal(this.clientListService, rowAction.model.id, undefined, undefined, undefined, 5);
        break;
      case ActionIdEnum.Select:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.selectClient(rowAction.model.id);
        }
        break;
    }
  }

}
